import styled from "styled-components";
import { transparentize } from "polished";
import { media } from "../../../styles/breakpoints";
import { neutral10, neutral1, brandhighlight } from "../../../css/colors";
const buttonSizeXsmall = "9.067vw";
const buttonSizeMobile = "6.2vw";
const buttonSizeTablet = "4.427vw";
const buttonSizeDesktop = "2.917vw";
const buttonSizeCinema = "2.6vw";
export const ButtonBase = styled.button `
  position: absolute;
  top: 50%;
  transform: translateY(-50%) scale(1.001);
  z-index: 10;
  pointer-events: none;
  background-color: ${neutral10};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;
  height: ${buttonSizeXsmall};
  width: ${buttonSizeXsmall};
  opacity: 0;

  @media ${media.xsmall.up} {
    width: ${buttonSizeMobile};
    height: ${buttonSizeMobile};
  }

  @media ${media.small.up} {
    width: ${buttonSizeTablet};
    height: ${buttonSizeTablet};
  }

  @media ${media.medium.up} {
    width: ${buttonSizeDesktop};
    height: ${buttonSizeDesktop};
  }

  @media ${media.large.up} {
    width: ${buttonSizeCinema};
    height: ${buttonSizeCinema};
  }

  &.forceShow {
    opacity: 1;
  }

  &:before,
  &:after {
    height: 10%;
    width: 39%;
    content: "";
    position: absolute;
    border-radius: 0.4em;
    background: ${brandhighlight};
  }

  &:before {
    top: 55.5%;
  }

  &:after {
    bottom: 55.5%;
  }
`;
export const ButtonPrev = styled(ButtonBase) `
  box-shadow: 2px 2px 4px ${transparentize(0.6, neutral1)};
  left: -2.5vw;

  @media ${media.medium.up} {
    left: -2.222vw;
  }

  @media ${media.large.up} {
    left: -2vw;
  }

  &:before,
  &:after {
    right: 32%;
  }

  &:before {
    transform: rotate(-135deg);
  }

  &:after {
    transform: rotate(135deg);
  }
`;
export const ButtonNext = styled(ButtonBase) `
  box-shadow: -2px 2px 4px ${transparentize(0.6, neutral1)};
  right: -2.5vw;

  @media ${media.medium.up} {
    right: -2.222vw;
  }

  @media ${media.large.up} {
    right: -2vw;
  }

  &:before,
  &:after {
    left: 32%;
  }

  &:before {
    transform: rotate(-45deg);
  }

  &:after {
    transform: rotate(45deg);
  }
`;

